import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { nrAction, nrError } from '../helpers/newrelic.helper';

@Injectable()
export class NewRelicLoggingInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const started = Date.now();

    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            const isError = event.status >= 400;
            nrAction(isError ? 'api_error' : 'api_response', {
              method: req.method,
              url: req.urlWithParams,
              status: event.status,
              duration_ms: Date.now() - started,
            });
            if (isError) {
              nrError(`HTTP ${event.status}`, {
                method: req.method,
                url: req.urlWithParams,
                status: event.status,
              });
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          nrAction('api_error', {
            method: req.method,
            url: req.urlWithParams,
            status: err.status,
            message: err.message,
            duration_ms: Date.now() - started,
          });
          nrError(err, {
            method: req.method,
            url: req.urlWithParams,
            status: err.status,
          });
        },
      }),
    );
  }
}
